import type { ChatMessage } from "./chatApi";



/**
 * Mise à jour locale des réactions (une réaction par utilisateur côté serveur).
 * `removing` = on retire notre réaction sur cet emoji (toggle off).
 */
export const applyReactionToggleOptimistic = (messages: ChatMessage[], messageId: string, emoji: string, removing: boolean): ChatMessage[] => {
  return messages.map((m) => {
    if (m.id !== messageId) return m;
    const reactions = [...(m.reactions ?? [])];
    if (removing) {
      const next = reactions
        .map((r) => {
          if (r.emoji !== emoji || !r.reactedByMe) return r;
          const newCount = r.count - 1;
          if (newCount <= 0) return null;
          return { emoji: r.emoji, count: newCount, reactedByMe: false };
        })
        .filter((r): r is NonNullable<typeof r> => r != null);
      return { ...m, reactions: next };
    }
    const withoutMine = reactions
      .map((r) => {
        if (!r.reactedByMe) return r;
        const newCount = r.count - 1;
        if (newCount <= 0) return null;
        return { emoji: r.emoji, count: newCount, reactedByMe: false };
      })
      .filter((r): r is NonNullable<typeof r> => r != null);
    const idx = withoutMine.findIndex((r) => r.emoji === emoji);
    let next: NonNullable<ChatMessage["reactions"]>;
    if (idx >= 0) {
      const row = withoutMine[idx]!;
      const bumped: (typeof row) & { reactedByMe: true } = {
        emoji: row.emoji,
        count: row.count + 1,
        reactedByMe: true,
      };
      next = [...withoutMine.slice(0, idx), bumped, ...withoutMine.slice(idx + 1)];
    } else {
      next = [...withoutMine, { emoji, count: 1, reactedByMe: true }].sort((a, b) =>
        a.emoji.localeCompare(b.emoji, "fr"),
      );
    }
    return { ...m, reactions: next };
  });
}
